export function cleanTemplateTitle(value) {
  return String(value || "")
    .replace(/\s*\|\s*Canvas\s*$/iu, "")
    .trim();
}

function humanize(value) {
  return String(value || "")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function pageVariant(page) {
  if (page.sourceType === "blogger") return "";
  const base = `demo-${page.familyId}`;
  return page.id === base ? "" : page.id.slice(base.length).replace(/^-/, "");
}

function translatedFamily(page, t) {
  return t(`catalog.families.${page.familyId}`, {
    defaultValue: humanize(page.familyId),
  });
}

function translatedVariant(page, t) {
  const variant = pageVariant(page);
  if (!variant) return "";
  return t(`catalog.pageTypes.${variant}`, {
    defaultValue: humanize(variant),
  });
}

export function templateTitle(page, language, t) {
  if (page.sourceType === "blogger") {
    return language?.startsWith("vi")
      ? t("catalog.bloggerTitle", { name: page.name || page.title })
      : `${page.name || page.title} Blogger`;
  }
  if (!language?.startsWith("vi")) return cleanTemplateTitle(page.title);
  const parts = [translatedFamily(page, t), translatedVariant(page, t)].filter(
    Boolean,
  );
  return parts.join(" — ").normalize("NFC").toLocaleUpperCase("vi-VN");
}

export function templateDescription(page, language, t) {
  if (page.sourceType === "blogger") {
    return t("catalog.descriptionBlogger", {
      name: page.name || page.title,
      count: page.widgetCount || 0,
    });
  }
  if (!language?.startsWith("vi")) {
    return (
      page.description ||
      t("catalog.descriptionFallback", {
        name: cleanTemplateTitle(page.title),
      })
    );
  }
  const name = translatedFamily(page, t);
  const variant = translatedVariant(page, t);
  if (variant) {
    return t("catalog.descriptionPage", {
      name,
      page: variant.toLocaleLowerCase("vi-VN"),
    }).normalize("NFC");
  }
  return t(
    page.kind === "landing"
      ? "catalog.descriptionLanding"
      : "catalog.descriptionWebsite",
    { name, count: page.sitePages.length },
  ).normalize("NFC");
}
